var React = require('react');

function GalleryNextButton (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M25.0826 7.03033C25.3755 6.73744 25.3755 6.26256 25.0826 5.96967L20.3096 1.1967C20.0167 0.903805 19.5418 0.903805 19.2489 1.1967C18.9561 1.48959 18.9561 1.96447 19.2489 2.25736L23.4916 6.5L19.2489 10.7426C18.9561 11.0355 18.9561 11.5104 19.2489 11.8033C19.5418 12.0962 20.0167 12.0962 20.3096 11.8033L25.0826 7.03033ZM24.5522 5.75L0.552246 5.75L0.552246 7.25L24.5522 7.25L24.5522 5.75Z","fill":"#194550"}));
}

GalleryNextButton.defaultProps = {"width":"26","height":"13","viewBox":"0 0 26 13","fill":"none"};

module.exports = GalleryNextButton;

GalleryNextButton.default = GalleryNextButton;
